import React from 'react';
import { loginPath } from 'Consts/Strings';
import { FDFacetLogo } from '@facet-wealth/design';
import { NavButton } from '../NavButton';

export function buildBuyWizNav({ homePage }) {
  return function BuyWizNav() {
    // BE CAREFUL ADJUSTING THIS FILE!
    // EVEN THE SLIGHTEST ADJUSTMENT CAN CAUSE THE UI TO WRAP AT ITS MOBILE BREAKPOINT (960px at time of writing)
    return (
      <>
        <div>
          {homePage && <NavButton value="logo" to={homePage} label={<FDFacetLogo size="md" />} />}
        </div>
        <div>
          <NavButton value="login" to={loginPath} label="Log In" />
        </div>
      </>
    );
  };
}
